import { render, staticRenderFns } from "./CustomerMy.vue?vue&type=template&id=3fa24f9e&scoped=true"
import script from "./CustomerMy.vue?vue&type=script&lang=js"
export * from "./CustomerMy.vue?vue&type=script&lang=js"
import style0 from "./CustomerMy.vue?vue&type=style&index=0&id=3fa24f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa24f9e",
  null
  
)

export default component.exports